<div class="bg-grey-100 px-24 pb-12 pt-16 md:hidden">
    <h2 class="text-31 leading-36">{{ servicesHero().headline }}</h2>
    <h2 class="text-16 leading-27">{{ locationHeadline() }}</h2>
</div>

<ui-m030-c020-teaser-allrounder
    [list]="bullets()"
    [strongText]="servicesHero().subHeadline"
    [image]="servicesHero().heroImage.url"
    [imageAlt]="servicesHero().heroImage.alt || servicesHero().headline"
    [isFirstView]="true"
>
    <h2 class="hidden md:block" headline>{{ servicesHero().headline }}</h2>
    <h2 class="mb-24 hidden md:block" subheadline>{{ locationHeadline() }}</h2>
    <div class="ml-20" [editable]="'services.serviceBullet'" [type]="'text'" bulletEdit></div>

    <ng-container cta>
        <div>
            <a
                class="button-primary md:w-auto"
                [hyundaiRouterLink]="dealer().pages.serviceForm"
                [trackingElTarget]="dealer().pages.serviceForm"
                tracking
                trackingEvent="engagement_click"
                trackingElType="button"
                trackingElLabel="Service Request"
            >
                Jetzt Termin vereinbaren
            </a>
        </div>
    </ng-container>
</ui-m030-c020-teaser-allrounder>

@if (keyCampaign(); as keyCampaign) {
    @if (keyCampaign.content?.__typename === 'AfterSale') {
        <a ui-m040-c040-promotion-banner [hyundaiRouterLink]="keyCampaign.detailUrl">
            @let teaserHeadline = keyCampaign.teaserHeadline | footnotes;

            <span [innerHTML]="teaserHeadline()"></span>
            <br class="lg:hidden" />
            <span class="hidden lg:inline-block">-</span>
            @if (keyCampaign.teaserCopy) {
                @let teaserCopy = keyCampaign.teaserCopy | footnotes;
                <span [innerHTML]="teaserCopy()"></span>
            }
        </a>
    }
}
@if (!dealer().isSubDealer) {
    @if (servicesHero().contactEmployee; as contact) {
        <ui-m040-c130-contact-banner
            [contact]="contact"
            [cta]="dealer().phone"
            [ctaLink]="'tel:' + dealer().phone"
            [isFirstView]="true"
        >
            <div class="leading-22 flex flex-col gap-4 font-headline text-16">
                <p class="font-medium">Das Service-Team ist {{ dealer().openings.service.nextOpening }} für Sie da:</p>
                <p class="font-medium">
                    {{ serviceOpeningText() }}
                </p>
                <a
                    ui-m010-c020-icon-link
                    class="mt-8"
                    [hyundaiRouterLink]="dealer().pages.aboutUs"
                    [queryParams]="{ team: 'service-werkstatt' }"
                    [trackingElTarget]="dealer().pages.aboutUs + '?team=service-werkstatt'"
                    tracking
                    trackingEvent="engagement_click"
                    trackingElType="button"
                    trackingElLabel="Service Request (Phone)"
                    isFirstView
                >
                    Zum Service-Team
                </a>
            </div>
        </ui-m040-c130-contact-banner>
    }
}

@if (servicesHero().serviceTeaser.length > 0) {
    <div class="bg-white">
        <div class="inner-page-wrapper py-40 lg:pt-64">
            <h3 class="mb-20 text-center text-24 leading-28 lg:mb-64 lg:text-34 lg:leading-41">
                Unsere Service-Angebote
            </h3>
            <div class="grid grid-cols-2 gap-x-16 gap-y-48 lg:grid-cols-4 lg:gap-x-56">
                @for (teaser of servicesHero().serviceTeaser; track $index) {
                    <ui-m040-c050-card
                        [image]="teaser.image"
                        [headline]="teaser.link.text"
                        [link]="teaser.link.url"
                        [queryParams]="teaser.link.linkQueryParams"
                        flushContent
                        isFirstView
                    />
                }
            </div>
        </div>
    </div>
}

@if (servicesHero().serviceTextHeadline || servicesHero().serviceText) {
    <div class="w-full bg-grey-100">
        <div class="inner-page-wrapper py-24">
            <p class="font-headline text-16 font-medium leading-27" [editable]="'services.serviceTextHeadline'">
                {{ servicesHero().serviceTextHeadline }}
            </p>
            <p class="font-headline text-16 leading-27" [editable]="'services.serviceText'">
                {{ servicesHero().serviceText }}
            </p>
        </div>
    </div>
}

@if (generalServices(); as generelServices) {
    <div class="flex flex-col items-center">
        <div [editable]="'services.serviceHighlights'"></div>
        <div class="inner-page-wrapper flex grid-cols-3 flex-col gap-56 py-24 lg:grid">
            @for (generalService of generelServices.services; track $index) {
                <div class="flex gap-8 md:flex-col">
                    @if (generalService.icon?.url; as url) {
                        <div class="size-[40px] shrink-0">
                            <img [src]="url" width="50" height="50" alt="Service Icon" />
                        </div>
                    }
                    <div class="flex flex-col">
                        @let headline = generalService.headline | footnotes;
                        @let copy = generalService.copy || '' | footnotes;
                        <p class="leading-21 text-14 font-medium" [innerHTML]="headline()"></p>
                        <p class="leading-21 text-14" [innerHTML]="copy()"></p>

                        @if (generalService.link?.title && generalService.link?.url) {
                            <a
                                ui-m010-c020-icon-link
                                class="mt-8 flex items-center text-16 leading-20 text-accent"
                                [hyundaiRouterLink]="generalService.link?.url"
                                [queryParams]="{ service: generalService.id }"
                                [trackingElTarget]="
                                    dealer().name +
                                    '/service/' +
                                    generalService.link?.url +
                                    '?service=' +
                                    generalService.id
                                "
                                tracking
                                trackingEvent="engagement_click"
                                trackingElType="basic link"
                                trackingElLabel="Service Request"
                            >
                                {{ generalService.link?.title }}
                            </a>
                        }
                    </div>
                </div>
            }
        </div>
    </div>
}
@defer {
    <app-global-contact isFirstView="false" />
}
